export const STANDBY = 'STANDYBY';
export const LOADING = 'LOADING';
export const PLAYING = 'PLAYING';
export const PAUSED = 'PAUSED';
export const STOPPED = 'STOPPED';
export const ERROR = 'ERROR';
export const SKIPPED = 'SKIPPED';
export const REPLAY = 'REPLAY';
